// Author thq
// Date 2021-07-06 16:54:47

class EmSppRequisitionSpr {
constructor({
        id = null,
        workOrderCode = '',
        status = '',
        sprCodeRwo = '',
        sprIdRwo = '',
        sprCodeLoc = '',
        sprNameDept = '',
        sprIdDept = '',
        sprCodeEloc = '',
        sprIdEloc = '',
        sprIdReceiver = '',
        sprDateReceipt = ''}
= {}) {
    this.id = id;
    this.workOrderCode = workOrderCode;
    this.status = status;
    this.sprCodeRwo = sprCodeRwo;
    this.sprIdRwo = sprIdRwo;
    this.sprCodeLoc = sprCodeLoc;
    this.sprNameDept = sprNameDept;
    this.sprIdDept = sprIdDept;
    this.sprCodeEloc = sprCodeEloc;
    this.sprIdEloc = sprIdEloc;
    this.sprIdReceiver = sprIdReceiver;
    this.sprDateReceipt = sprDateReceipt;
}
}

function newEntity() {
return new EmSppRequisitionSpr();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprCodeRwo',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprCodeRwo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchLocName',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.emArchLocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprNameDept',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprNameDept',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprNameEloc',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprNameEloc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprNameReceiver',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprNameReceiver',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprNameAuditor',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprNameAuditor',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprNameExecutor',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprNameExecutor',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprDateApply',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprDateApply',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprDateReceipt',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.sprDateReceipt',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.spareparts.emSppRequisitionSpr.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    workOrderCodeFilter : "",
    statusFilter : "",
    sprIdRwoFilter : "",
    sprCodeLocFilter : "",
    sprIdDeptFilter : "",
    sprIdReceiverFilter : "",
    sprIdAuditorFilter : "",
    sprIdExecutorFilter : "",
    sprDateApplyRteFilter : "",
    sprDateApplyLteFilter : "",
    sprDateReceiptRteFilter : "",
    sprDateReceiptLteFilter : "",
    workflowQueryTypeFilter : "",
    emArchLocCodeFilter : "",
    emArchLocNodeCodeFilter : "",
    emArchLocNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'EmSppRequisitionSpr',statusFilter:1}
        }
        },
        {
        key: 'sprIdRwoFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprIdRwo',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'repairWorkOrder'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'sprIdDeptFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprIdDept',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'sprIdReceiverFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprIdReceiver',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'sprIdAuditorFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprIdAuditor',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'sprIdExecutorFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprIdExecutor',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'sprDateApplyRteFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprDateApplyRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sprDateApplyLteFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprDateApplyLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sprDateReceiptRteFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprDateReceiptRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sprDateReceiptLteFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.sprDateReceiptLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'emArchLocCodeFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.emArchLocCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.spareparts.emSppRequisitionSpr.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sprCodeRwo',
        label: 'label.em.spareparts.emSppRequisitionSpr.entity.sprCodeRwo',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'repairWorkOrder'
            ,correspondingField: 'workOrderCode'
            ,fieldsBindingByEntityModalSelected: '{"sprIdRwo":"id"}'
                }
        },
        {
        key: 'sprCodeLoc',
        label: 'label.em.spareparts.emSppRequisitionSpr.entity.sprCodeLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sprNameDept',
        label: 'label.em.spareparts.emSppRequisitionSpr.entity.sprNameDept',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"sprIdDept":"id"}'
                }
        },
        {
        key: 'sprCodeEloc',
        label: 'label.em.spareparts.emSppRequisitionSpr.entity.sprCodeEloc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppLocation'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"sprIdEloc":"id"}'
                }
        },
        {
        key: 'sprIdReceiver',
        label: 'label.em.spareparts.emSppRequisitionSpr.entity.sprIdReceiver',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'sprDateReceipt',
        label: 'label.em.spareparts.emSppRequisitionSpr.entity.sprDateReceipt',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
            ,required: true
                }
        }
]

export {EmSppRequisitionSpr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
